import { calendarConstants } from '../../_constants';

export function calendars(state = {}, action) {
    switch (action.type) {
        case calendarConstants.CALENDAR_FETCHING:
            return {
                ...state,
                calendarFetching: true
            };
        case calendarConstants.CALENDAR_FETCHED:
            return {
                ...state,
                calendarFetching: false
            };
        case calendarConstants.CALENDAR_SUBMITTING:
            return {
                ...state,
                calendarSubmitting: true
            };
        case calendarConstants.CALENDAR_SUBMITTED:
            return {
                ...state,
                calendarSubmitting: false
            };
        case calendarConstants.GET_ALL_HOLIDAYS:
            return {
                ...state,
                allHoliday: action.allHoliday,
            };
        case calendarConstants.GET_HOLIDAY_BY_ID:
            return {
                ...state,
                holidayById: action.holidayById
            };
        case calendarConstants.GET_ALL_WORKING_DAYS:
            return {
                ...state,
                allWorkDay: action.allWorkDay,
            };
        case calendarConstants.GET_WORK_DAY_BY_BRANCH:
            return {
                ...state,
                workDayByBranch: action.workDayByBranch,
            };
        case calendarConstants.GET_LOCAL_HOLIDAY_BY_BRANCH:
            return {
                ...state,
                HolidaybyBranch: action.HolidaybyBranch,
            };
        default:
            return state;
    }
}